import { keepPreviousData, useQuery } from '@tanstack/react-query';

import OffersService, { LuxPlusPurchaseRestrictionsListParams } from '~/services/OffersService';

export const luxPlusPurchaseRestrictionsQueryKeys = {
  all: ['lux-plus-purchase-restrictions'] as const,
  list: (params: LuxPlusPurchaseRestrictionsListParams) =>
    [...luxPlusPurchaseRestrictionsQueryKeys.all, 'list', params] as const,
};

export function useGetLuxPlusPurchaseRestrictions(params: LuxPlusPurchaseRestrictionsListParams) {
  return useQuery({
    queryKey: luxPlusPurchaseRestrictionsQueryKeys.list(params),
    queryFn: ({ signal }) => OffersService.getLuxPlusPurchaseRestrictions(params, { signal }),
    placeholderData: keepPreviousData,
  });
}
